import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import {
  IWSIBCodeRate,
  IWSIBCodeRateListPayload,
  IWSIBCodeRateResponse,
} from "../models/WSIBCodeRate";

import { GridSize } from "@mui/material";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IWSIBCodeListPayload, IWSIBCodeRequest, IWSIBCodeResponse } from '../models/wsibCode';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const WSIBCodeRateService = {
  getById: async (
    clientId: string,
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IWSIBCodeRate | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IWSIBCodeRate> =
        await http.get<IWSIBCodeRate>(`/v1/wsib-code-rate-setup/${id}/`);

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IWSIBCodeRate | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IWSIBCodeRate> =
          await http.put<IWSIBCodeRate>(
            `/v1/wsib-code-rate-setup/${requestPayload.id}/`,
            requestPayload,
          );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IWSIBCodeRate> =
        await http.post<IWSIBCodeRate>(
          `/v1/wsib-code-rate-setup/add-wsib-code-rate`,
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delWSIBCodeRate: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/wsib-code-rate-setup/${delPayload.wsibCodeRateId}/`,
      );

      if (response.status === 204) {
        return "WSIBCodeRate has been deleted successfully";
      } else if (response.status === 200) {
        return "WSIBCodeRate has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getWSIBCodeRateList: async (
    provinceId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    try {
      const response: AxiosResponse<any[]> = await http.get<any[]>(
        `/v1/wsib-code-rate-setup/?order_by=province&order_direction=asc&page=1&size=50`,
      );

      if (response.status === 200) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
};
